export enum ResetPasswordFormFieldNames {
  username = "username",
}

export type ResetPasswordFormFieldValues = {
  [ResetPasswordFormFieldNames.username]: string
}